import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    CardActions,
    SelectInput,
    downloadCSV,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import Exporter from './Exporter'


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);


export const ShipmentFilter = props => (
    <Filter {...props}>
            <DateInput source="shipping_date" alwaysOn lable='Shipping Date'/>
    </Filter>
);

export const ShipmentList = props => (
    <List 
        {...props}
        filters={<ShipmentFilter />}
        perPage={20}
        sort={{ field: 'shipping_date', order: 'DESC' }}
        bulkActionButtons ={false}
        exporter={Exporter}
        hasCreate = {false}
        >
        <Datagrid >
            <TextField source="case_no" label="Case#" />    
            <TextField source="shipping_case_no" label="Ship Case#" />
            <TextField source="ucn" label="Uint Control#" />
            <TextField source="ssn" label="SSN"/>
            <DateField source="bleed_date" label="Bleed Date"  locales="en-us"/>
            <TextField source="volume" label="Volume"/>
            <DateField source="shipping_date" label="Shipping Date"  locales="en-us"/>
        </Datagrid>
    </List>
);


export default ShipmentList